import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import { translate } from '~/core/translate'
import { getItems } from '~/selectors/calendar'
import Modal from '../common/modal'

const Description = styled.div`
  display: flex;
  ${({ theme }) => ({ ...theme._neo.body02 })}
  color: ${props => props.theme.colorTertiary};
  margin-bottom: 6px;
`

const Calendars = styled.div`
  height: 100%;
  overflow-y: auto;
`

const ListItem = styled.div`
  margin-top: 10px;
  display: flex;
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
  color: ${props => props.theme.colorTertiary};
`

export const CalendarListDialog = ({ calendarList }) => (
  <Modal title={translate('calendars')}>
    <Description>{translate('synced_calendar_description')}</Description>
    <Calendars>
      {calendarList.map(calendar => (
        <ListItem key={calendar.id}>{calendar.name}</ListItem>
      ))}
    </Calendars>
  </Modal>
)

const mapStateToProps = state => ({
  calendarList: getItems(state)
})

export default connect(mapStateToProps)(CalendarListDialog)
